import ReorderControls from "../../common/ReorderControls";
import { newItemId, readItemListConfig } from "../item-list-model";
import ItemListPreview from "../ItemListPreview";
import FeatherIcon from "../../common/FeatherIcon";
import {
  useCallback,
  useEffect,
  useContext,
  useMemo,
  useState,
  forwardRef,
} from "react";
import { useHistory } from "react-router-dom";
import { AppContexts } from "../../../providers";
import { useForm } from "react-hook-form";
import AddQuestion from "../question_add";
import {
  SortableContainer,
  SortableElement,
} from "react-sortable-hoc";
import { arrayMoveImmutable } from "array-move";
import MultipleChoice from "../question_types/multiple-choice";
import ShortAnswer from "../question_types/short-answer";
import Checkboxes from "../question_types/checkboxes";
import Range from "../question_types/range";
import QuestionDelete from "../question_delete";
import moment from "moment";
import ConvertUTCDateToLocalDate from "../../common/ConvertUTCDateToLocalDate";
import UIkit from "uikit";

const SurveyEdit = () => {
  const {
    getSurvey,
    updateSurvey,
    setSurvey,
    setIsNew,
    setQuestion,
    initQuestion,
    setQuestionNo,
  } = useContext(AppContexts.SurveysContext);
  const surveysContext = useContext(AppContexts.SurveysContext);
  const history = useHistory();
  const [reordering, setReordering] = useState(false);
  const [editName, setEditName] = useState(false);
  const [editIntro, setEditIntro] = useState(false);
  const [duplicatedQuestionId, setDuplicatedQuestionId] = useState(null);
  const { register, setValue, getValues } = useForm();

  useEffect(() => {
    document.title = "Edit Survey - RueBaRue";
    let survey_id = history.location.pathname.split("/")[2];
    getSurvey(survey_id);
  }, []);

  const handleBack = useCallback(() => {
    history.goBack();
  }, []);

  const survey = useMemo(() => {
    if (!surveysContext.survey) {
      return {};
    } else {
      let temp = surveysContext.survey;
      let realQuestions = [];
      if (surveysContext.survey.question_order) {
        let orders = surveysContext.survey.question_order.split(",");
        realQuestions = orders
          .map((order_id) => {
            return surveysContext.survey.questions?.find(
              ({ survey_question_id, deleted }) =>
                survey_question_id.toString() === order_id.toString() &&
                deleted === false
            );
          })
          .filter((item) => !!item);
      }
      temp.questions = realQuestions;
      temp.questions.forEach((question) => {
        let realOptions = [];
        if (question.option_order) {
          let orders = question.option_order.split(",");
          realOptions = orders
            .map((order_id) => {
              return question.question_options?.find(
                ({ survey_question_option_id, deleted, type }) => {
                  return (
                    (+survey_question_option_id == +order_id ||
                      +type == +order_id) &&
                    deleted == false
                  );
                }
              );
            })
            .filter((item) => !!item);
          question.question_options = realOptions;
        }
      });
      return temp;
    }
  }, [surveysContext.survey]);

  useEffect(() => {
    if (duplicatedQuestionId === null) return;
    const category = document.getElementById(
      `survey-question-${duplicatedQuestionId}`,
    );
    if (category) {
      category.scrollIntoView({ behavior: "smooth", block: "center" });
      setDuplicatedQuestionId(null);
    }
  }, [survey, duplicatedQuestionId]);

  useEffect(() => {
    console.log(survey);
  }, [survey]);

  const handleEditName = async () => {
    let name = getValues("name");
    let sv = { ...survey };
    delete sv.questions;
    let res = await updateSurvey({
      ...sv,
      name: name,
    });
    setSurvey((prev) => {
      return { ...prev, ...res };
    });
    setValue("name", name);
    setEditName(false);
  };

  const handleEditIntro = async () => {
    let intro = getValues("intro");
    let sv = { ...survey };
    delete sv.questions;
    let res = await updateSurvey({
      ...sv,
      intro: intro,
    });
    setSurvey((prev) => {
      return { ...prev, ...res };
    });
    setValue("intro", intro);
    setEditIntro(false);
  };

  const handleEditQuestion = (index) => {
    setIsNew(false);
    setQuestion(survey?.questions[index]);
  };

  const handleAddQuestion = () => {
    setIsNew(true);
    initQuestion();
  };

  const orderOptions = (options, order) => {
    return order
      .map((id) =>
        (options || []).find((o) => {
          return +o.type === +id || +o.survey_question_option_id === +id;
        })
      )
      .filter((o) => {
        return !!o;
      });
  };

  const SortableItem = SortableElement(
    forwardRef(({ question, no }, ref) => {
      return (
        <div
          id={`survey-question-${question.survey_question_id}`}
          className="uk-card uk-card-small uk-card-default hms-property-card"
          key={no}
          ref={ref}
        >
          <div className="uk-flex uk-flex-between">
            <div className="hms-property-card-body">
              <div className="hms-property-card-content">
                <h4 className="card-heading-small">{question?.question}</h4>
                <div className="secondary">{question?.help_text}</div>
                <div>
                  {question?.question_type === "item-list" && <ItemListPreview config={question.config} />}
                  {question?.question_type === "multiple-choice" && (
                    <MultipleChoice
                      options={orderOptions(
                        question?.question_options,
                        (question?.option_order || "").split(",")
                      )}
                      index={no}
                      other={question?.include_other}
                    />
                  )}
                  {question?.question_type === "short-answer" && (
                    <ShortAnswer />
                  )}
                  {question?.question_type === "checkboxes" && (
                    <Checkboxes
                      options={orderOptions(
                        question?.question_options,
                        (question?.option_order || "").split(",")
                      )}
                      index={no}
                      other={question?.include_other}
                    />
                  )}
                  {question?.question_type === "range-5" && (
                    <Range question={question} index={no} type={5} />
                  )}
                  {question?.question_type === "range-10" && (
                    <Range question={question} index={no} type={10} />
                  )}
                </div>
              </div>
            </div>
            <div className="hms-property-card-btn">
              <div>
                <button
                  type="button"
                  className="uk-button"
                  uk-toggle="target: #modal-question-add"
                  onClick={() => handleEditQuestion(no)}
                  uk-tooltip="Edit"
                >
                  <FeatherIcon name="edit-3" />
                </button>
              </div>
              <hr />
              {question.question_type === "item-list" && <button type="button" className="uk-button" aria-label="Duplicate category" uk-tooltip="Duplicate category" onClick={async () => {
                try {
                  const config = readItemListConfig(question.config);
                  if (!config) throw new Error("The saved item list could not be loaded. Reload before duplicating.");
                  const copy = { ...question, survey_question_id: undefined, question: `${question.question} (copy)`,
                    config: { ...config, items: config.items.map((item) => ({ ...item, id: newItemId() })) }, question_options: [] };
                  const result = await surveysContext.upsertQuestion(copy);
                  if (!result) return;
                  UIkit.notification("Category duplicated successfully.", "success");
                  setDuplicatedQuestionId(result.survey_question_id);
                  await getSurvey(survey.survey_id);
                } catch (error) { window.alert(error.response?.data?.error || error.message || "Unable to duplicate category"); }
              }}><FeatherIcon name="copy" /></button>}
              {question.question_type === "item-list" && <hr />}
              <ReorderControls id={`question-${question.survey_question_id}`} noun="question"
                index={no} count={survey.questions.length} disabled={reordering}
                onMove={(oldIndex, newIndex) => handleReorder({ oldIndex, newIndex })} />
              <hr />
              <div>
                <button
                  type="button"
                  className="uk-button"
                  uk-toggle="target: #question-delete-modal"
                  onClick={() => setQuestionNo(no)}
                  uk-tooltip="Delete"
                >
                  <FeatherIcon name="trash-2" />
                </button>
              </div>
            </div>
          </div>
        </div>
      );
    })
  );

  const SortableList = SortableContainer(({ questions = [] }) => (
    <div className="uk-width-1-1">
      {questions.map((question, index) => (
        <SortableItem question={question} no={index} index={index}
          key={question.survey_question_id} />
      ))}
    </div>
  ));

  const handleReorder = async ({ oldIndex, newIndex }) => {
    if (reordering || newIndex < 0 || newIndex >= survey.questions.length) return;
    const order = arrayMoveImmutable(survey.questions, oldIndex, newIndex)
      .map((item) => item.survey_question_id).join();
    const { questions, ...payload } = survey;
    setReordering(true);
    try {
      const saved = await updateSurvey({ ...payload, question_order: order });
      if (!saved) throw new Error("Unable to save question order. Please try again.");
      setSurvey((prev) => ({ ...prev, question_order: order }));
    } catch (error) {
      window.alert(error.message || "Unable to save question order. Please try again.");
    } finally {
      setReordering(false);
    }
  };

  return (
    <>
      <div id="surveys-detail-template">
        <div id="hms-page-title">
          <div className="uk-flex">
            <button
              type="button"
              className="uk-button hms-img-btn go-back-arrow-btn"
              onClick={handleBack}
            >
              <span uk-icon="icon: arrow-left; ratio: 1" style={{ color: "var(--dark-purple)" }}></span>
            </button>
            <div className="surveys-detail-body uk-flex-1">
              <div className="uk-flex uk-flex-middle">
                {editName === true && (
                  <>
                    <input
                      type="text"
                      {...register("name")}
                      className="survey-edit-name"
                      style={{ width: `${survey?.name.length + 10}ch` }}
                    />
                    <span onClick={handleEditName}>
                      <span className="uk-icon-button"><FeatherIcon name="check" /></span>
                    </span>
                    <span onClick={() => setEditName(false)}>
                      <span className="uk-icon-button"><FeatherIcon name="x" /></span>
                    </span>
                  </>
                )}
                {editName === false && (
                  <>
                    <h1 className="uk-heading-small">{survey?.name}</h1>
                    <button
                      type="button"
                      className="uk-button hms-simple-icon-btn"
                      onClick={() => {
                        setValue("name", survey?.name);
                        setEditName(true);
                      }}
                    >
                      <FeatherIcon name="edit-2" />
                    </button>
                  </>
                )}
              </div>
              <div className="uk-flex uk-flex-middle survey-edit-intro-section">
                {editIntro === true && (
                  <>
                    <input
                      type="text"
                      {...register("intro")}
                      className="survey-edit-intro"
                      style={{
                        width: `${
                          survey.intro !== "" && survey.intro
                            ? survey.intro.length + 10
                            : 30
                        }ch`,
                      }}
                    />
                    <span onClick={handleEditIntro}>
                      <span className="uk-icon-button"><FeatherIcon name="check" /></span>
                    </span>
                    <span onClick={() => setEditIntro(false)}>
                      <span className="uk-icon-button"><FeatherIcon name="x" /></span>
                    </span>
                  </>
                )}
                {editIntro === false &&
                  (survey?.intro == "" || survey.intro == null ? (
                    <div>Add Intro Text for Your Survey</div>
                  ) : (
                    <div>{survey?.intro}</div>
                  ))}
                {editIntro === false && (
                  <button
                    type="button"
                    className="uk-button hms-simple-icon-btn"
                    onClick={() => {
                      setEditIntro(true);
                      setValue(
                        "intro",
                        survey.intro == null ? "" : survey.intro
                      );
                    }}
                  >
                    <FeatherIcon name="edit-2" />
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>

        <div id="hms-main-body">
          <div className="uk-flex uk-flex-between uk-flex-top">
            <div className="hms-guest-btn">
              <button
                className="uk-button hms-btn hms-red-btn survey-add-question-btn"
                uk-toggle="target: #modal-question-add"
                onClick={handleAddQuestion}
              >
                <FeatherIcon name="plus" /> QUESTION
              </button>
              <button
                type="button"
                className="uk-button hms-btn hms-white-btn uk-margin-small-left"
                disabled={!survey?.survey_id}
                onClick={() => window.open(`/surveys/${survey.survey_id}/preview`, "_blank", "noopener,noreferrer,width=1200,height=900")}
              >
                Preview
              </button>
            </div>
          </div>
          <SortableList
            questions={survey?.questions}
            order={survey?.question_order || ""}
            useDragHandle={true}
            onSortEnd={handleReorder}
          />
          <>
            {survey?.updated_at && (
              <div className="s-msg-last-updated">
                <ConvertUTCDateToLocalDate
                  date={survey.updated_at}
                  label="Last Updated: "
                />
              </div>
            )}
            {survey?.created_at && (
              <div className="s-msg-last-updated">
                <ConvertUTCDateToLocalDate
                  date={survey.created_at}
                  label="Added at: "
                />
              </div>
            )}
          </>
        </div>
      </div>
      <AddQuestion />
      <QuestionDelete />
    </>
  );
};

export default SurveyEdit;
